<template>
    <div>
        <div class="menu-title">
            本地模型管理
        </div>
        <div class="menu-content">
            <div>
                <el-form  :inline="true" :model="qo" size="small" class="demo-form-inline">
                  <el-form-item label="模型名称：">
                    <el-input v-model="qo.LIKES_name" placeholder="请输入模型名称" style="width: 300px"></el-input>
                  </el-form-item>
                  <el-form-item >
                    <el-button type="success" icon="el-icon-search" @click="qo.pageNo=1;queryData()">搜 索</el-button>
                  </el-form-item>
                </el-form>
            </div>
            <div style="margin: 0px 0 20px 0">
                <el-button type="primary" icon="el-icon-plus" size="small" @click="createRow()">添加</el-button>
                <el-button type="primary" size="small" icon="el-icon-upload2" @click="uploadRow()">导入</el-button>
                <el-button type="primary" size="small" icon="el-icon-download" @click="exportTemplate()">下载模版</el-button>
            </div>
            <div class="table-list">
                <el-table :data="result.records" style="width: 100%" >
                    <el-table-column type="index" label="序号" width="100" ></el-table-column>
                    <el-table-column prop="name" label="模型名称" ></el-table-column>
                    <el-table-column prop="size" label="模型大小" >
                      <template slot-scope="scope">
                        {{scope.row.size}}b
                      </template>
                    </el-table-column>
                    <el-table-column prop="usedVram" label="占用显存" >
                      <template slot-scope="scope">
                        {{scope.row.usedVram}}G
                      </template>
                    </el-table-column>
                    <el-table-column prop="score" label="综合评分" ></el-table-column>
                    <el-table-column prop="effect" label="记忆力" ></el-table-column>
                    <el-table-column prop="onlineTime" label="上线日期" ></el-table-column>
                    <el-table-column prop="name" label="状态" >
                      <template slot-scope="scope">
                        {{scope.row.status?"启用":"未启用"}}
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="160">
                        <template slot-scope="scope">
                            <el-button @click.native.prevent="statusRow(scope.row)"  type="text" size="small">
                              {{scope.row.status?"禁用":"启用"}}
                            </el-button>
                            <el-button @click.native.prevent="modifyRow(scope.row)"  type="text" size="small">
                                编辑
                            </el-button>
                            <el-button @click.native.prevent="removeRow(scope.row)"  type="text" size="small">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page-box">
                <el-pagination background
                               @current-change="handleCurrentChange"
                               :current-page="qo.pageNo"
                               :page-size="qo.pageSize"
                               :page-sizes="[10,20,30,40,50]" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next"
                               :total="result.total">
                </el-pagination>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false"
                :title="dialogName"
                :visible.sync="cmdDialogVisible"
                width="40%">
            <el-form ref="cmd" label-width="80px" :rules="rules" :model="cmd">
                <el-form-item label="模型名称" prop="label">
                    <el-input v-model="cmd.name" placeholder="请输入模型名称" @change="changeName"></el-input>
                </el-form-item>
                <el-form-item label="模型大小" prop="size">
                  <el-input v-model="cmd.size" placeholder="请输入模型大小" @input="(val) => handleDecimalInput(val, 'size')">
                    <template slot="append">b</template>
                  </el-input>
                </el-form-item>
                <el-form-item label="占用显存" prop="usedVram">
                  <el-input v-model="cmd.usedVram" placeholder="请输入占用显存"  @input="(val) => handleDecimalInput(val, 'usedVram')">
                    <template slot="append">G</template>
                  </el-input>
                </el-form-item>
                <el-form-item label="综合评分" prop="score">
                  <el-input v-model.number="cmd.score" placeholder="请输入综合评分" ></el-input>
                </el-form-item>
                <el-form-item label="记忆力" prop="effect">
                  <el-select v-model="cmd.effect" placeholder="请选择记忆力"  style="width: 100%">
                    <el-option v-for="item in memoryList" :value="item.name" :label="item.name"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="最小内存" prop="minMemory">
                  <el-input v-model.number="cmd.minMemory" placeholder="请输入最小内存"  @input="(val) => handleDecimalInput(val, 'minMemory')">
                    <template slot="append">G</template>
                  </el-input>
                </el-form-item>
                <el-form-item label="最小显存" prop="minVram">
                  <el-input v-model.number="cmd.minVram" placeholder="请输入最小显存"  @input="(val) => handleDecimalInput(val, 'minVram')">
                    <template slot="append">G</template>
                  </el-input>
                </el-form-item>
              <el-form-item label="速度" prop="speed">
                <el-input v-model="cmd.speed" placeholder="请输入速度"></el-input>
              </el-form-item>
              <el-form-item label="上线时间" prop="onlineTime">
                <el-date-picker style="width: 100%"
                    v-model="cmd.onlineTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="格式预设" prop="formatPresetId">
                <el-select v-model="cmd.formatPresetId" style="width: 100%" placeholder="请选择格式预设">
                  <el-option :value="item.id" :label="item.name" v-for="item in presetsList" v-if="item.type == 1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="模式预设" prop="modePresetId">
                <el-select v-model="cmd.modePresetId" style="width: 100%" placeholder="请选择模式预设">
                  <el-option :value="item.id" :label="item.name" v-for="item in presetsList"  v-if="item.type == 2 && item.modelType == 'local'"></el-option>
                </el-select>
              </el-form-item>
<!--              <el-form-item label="是否推荐" prop="recommend">-->
<!--                <el-radio v-model="cmd.recommend" :label="true">是</el-radio>-->
<!--                <el-radio v-model="cmd.recommend" :label="false">否</el-radio>-->
<!--              </el-form-item>-->
              <el-form-item label="效果" prop="introduce">
                <el-input v-model="cmd.introduce" placeholder="请输入效果" type="textarea" :rows="5"></el-input>
              </el-form-item>
              <el-form-item label="多模态" prop="multimodalArray">
                <el-select v-model="cmd.multimodalArray" multiple placeholder="请选择" style="width: 100%">
                  <el-option label="文本" value="文本"></el-option>
                  <el-option label="图片" value="图片"></el-option>
                  <el-option label="语音" value="语音"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="激活参数量" prop="paramNum">
                <el-input v-model.number="cmd.paramNum" placeholder="请输入激活参数量"  @input="(val) => handleDecimalInput(val, 'paramNum')">
                  <template slot="append">b</template>
                </el-input>
              </el-form-item>
              <el-form-item label="激活参数量描述" prop="paramNumDescription">
                <el-input v-model="cmd.paramNumDescription" placeholder="请输入描述" type="textarea" :rows="5"></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cmdDialogVisible = false"  size="small">取 消</el-button>
                <el-button type="primary" @click="submitModify"  size="small">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :close-on-click-modal="false"
                   title="导入"
                   :visible.sync="uploadDialogVisible"
                   width="40%">
          <el-form ref="cmd"  :rules="rules" :model="cmd">
            <el-form-item label="选择文件：" prop="file">
              <el-upload
                  ref="upload"
                  :auto-upload="false"
                  action="#" accept=".xlsx,.xls"
                  :on-change="handleFileChange"
                  :limit="2"
                  :show-file-list="false">
                <el-button type="primary" icon="el-icon-upload2" size="small">上传文件</el-button>
              </el-upload>
              <div>{{cmd.fileName}}</div>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
                <el-button @click="uploadDialogVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="submitUpload"  :loading="btLoading"  size="small">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import request, {getBaseUrl, getFileUrl} from '@/utils/request';
import {getToken} from "@/utils/auth";
import axios from "axios";
import {getMemoryList, memoryList} from "@/utils/common";

    var _this;
    export default {
        name: "unitManage",
        data() {
            return {
                qo: {
                    pageNo: 1,
                    pageSize: 10,
                    LIKES_name: '',
                    DESCI_createTime:1,
                },
                result: {
                    records: [],
                    total: 0
                },
                dialogName: '编辑',
                cmdDialogVisible: false,
                cmd: {},
                rules: {
                    sorce:[
                      { type: 'number', message: '综合评分必须为数字值'}
                    ],
                },
                imageUrl:"",
                path:getFileUrl(),
                uploadDialogVisible: false,
                btLoading:false,
                presetsList:[],
                memoryList:getMemoryList()
            }
        },
        mounted() {
            _this = this;
            _this.queryData();
            _this.queryPreset()
        },
        methods: {
            queryData() {
                request({
                    url: '/public/local-model/query_pages',
                    method: 'post',
                    data: _this.qo
                }).then(res => {
                    _this.result.records = res.records;
                    _this.result.total = res.total;
                });
            },
            queryPreset(){
              request({
                url: '/public/presets/query_list',
                method: 'post',
                data: {}
              }).then(res => {
                _this.presetsList = res;
              });
            },
            handleCurrentChange(val) {
                _this.qo.pageNo = val;
                _this.queryData();
            },
            handleSizeChange(val) {
                _this.qo.pageNo = 1;
                _this.qo.pageSize = val;
                _this.queryData();
            },
            removeRow(item) {
                _this.$confirm('此操作将永久删除记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    request({
                        url: '/public/local-model/remove/' + item.id,
                        method: 'post'
                    }).then(res => {
                        _this.$message.success("删除成功");
                        _this.queryData();
                    });
                }).catch(() => {
                });
            },
            createRow() {
                _this.dialogName = '添加';
                _this.imageUrl = ""
                _this.cmdDialogVisible = true;
                _this.$nextTick(() => {
                    _this.cmd = {
                        size: "",
                        name:"",
                        recommend:true,
                        usedVram:"",
                        speed:"",
                        score:"",
                        effect:"",
                        performance:"",
                        minMemory:"",
                        minVram:"",
                        source:"",
                        introduce:"",
                        onlineTime:"",
                        formatPresetId:"",
                        formatPresetName:"",
                        modePresetId:"",
                        modePresetName:"",
                        multimodalArray:['文本'],
                        multimodal:"",
                        paramNum:"",
                        paramNumDescription:""
                    };

                      _this.presetsList.forEach(item => {
                        if (item.type == 1 && item.isSelect) {
                          _this.cmd.formatPresetId = item.id
                          _this.cmd.formatPresetName = item.name
                        }
                        if (item.type == 2 && item.modelType == 'local' && item.isSelect) {
                          _this.cmd.modePresetId = item.id
                          _this.cmd.modePresetName = item.name
                        }
                      })
                    _this.$refs.cmd.resetFields();
                });
            },
            modifyRow(item) {
                _this.dialogName = '编辑';
                _this.imageUrl = ""
                _this.cmdDialogVisible = true;
                _this.$nextTick(() => {
                    if(item.url){
                      _this.imageUrl = _this.path + item.url;
                    }else{
                      _this.imageUrl = ""
                    }
                    if(item.multimodal){
                      item.multimodalArray = item.multimodal.split(",")
                    }else{
                      item.multimodalArray = []
                    }
                    _this.cmd = JSON.parse(JSON.stringify(item))

                    _this.$refs.cmd.resetFields();
                });
            },
            statusRow(item) {
              _this.$confirm('此操作将'+(item.status?'禁用':'启用')+', 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                let param = JSON.parse(JSON.stringify(item))
                param.status = !param.status
                request({
                  url: '/public/local-model/modify',
                  method: 'post',
                  data: param
                }).then(res => {
                  _this.$message.success((item.status?'禁用':'启用')+"成功");
                  _this.queryData();
                });
              }).catch(() => {
              });
            },
            submitModify() {
                this.$refs.cmd.validate((valid) => {
                    if (valid) {
                        if(_this.cmd.formatPresetId){
                          this.presetsList.forEach(item => {
                            if(item.id == _this.cmd.formatPresetId){
                              _this.cmd.formatPresetName = item.name
                            }
                          })
                        }
                        if(_this.cmd.modePresetId){
                          this.presetsList.forEach(item => {
                            if(item.id == _this.cmd.modePresetId){
                              _this.cmd.modePresetName = item.name
                            }
                          })
                        }
                        if(_this.cmd.multimodalArray && _this.cmd.multimodalArray.length > 0){
                          _this.cmd.multimodal = _this.cmd.multimodalArray.join(",")
                        }else{
                          _this.cmd.multimodal = ""
                        }
                        if (_this.cmd.id && _this.cmd.id.toString.length > 0) {
                            request({
                                url: '/public/local-model/modify',
                                method: 'post',
                                data: _this.cmd
                            }).then(res => {
                                _this.$message.success("编辑成功");
                                _this.cmdDialogVisible = false;
                                _this.queryData();
                            });
                        } else {
                            request({
                                url: '/public/local-model/create',
                                method: 'post',
                                data: _this.cmd
                            }).then(res => {
                                _this.$message.success("添加成功");
                                _this.cmdDialogVisible = false;
                                _this.queryData();
                            });
                        }
                    }
                });
            },
            //打开上传弹框
            uploadRow() {
              _this.btLoading = false;
              _this.uploadDialogVisible = true;
              _this.$nextTick(() => {
                _this.cmd = {
                  file: '',
                  fileName:""
                };
                _this.$refs.cmd.resetFields();
              });
            },
            submitUpload(){
              this.$refs.cmd.validate((valid) => {
                if (valid) {
                  _this.btLoading = true;
                  let formData = new FormData();
                  formData.append("file", _this.cmd.file);
                  request({
                    url: "/public/local-model/import",
                    method: 'post',
                    data: formData
                  }).then(res => {
                    _this.$message.success("导入成功");
                    _this.queryData()
                    _this.uploadDialogVisible = false;
                  }).catch(error =>{
                    _this.btLoading = false;
                  })
                }
              });
            },
            handleFileChange(file){
              this.$refs.upload.clearFiles();

              let FileExt = file.raw.name.replace(/.+\./, "");
              let msg = "请上传excel文件"
              if (['xlsx','xls'].indexOf(FileExt.toLowerCase()) === -1){
                this.$message({ type: 'warning', message: msg });
                return false;
              }
              _this.cmd.fileName = file.raw.name;
              _this.cmd.file = file.raw;
            },
            exportTemplate(){
              axios({
                method: 'post',
                url: getBaseUrl()+'/public/local-model/exportTemplate',
                data: {},
                responseType:"blob",
                headers:{
                  Authorization: getToken()
                }
              })
                  .then(function (res) {
                    const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // new一个二进制对象
                    const url = window.URL.createObjectURL(blob) // 转化为url
                    const link = document.createElement('a') // 创建个a标签
                    link.href = url
                    link.download = '本地模型模版'// 重命名
                    link.click()
                    URL.revokeObjectURL(url)
                  })
            },
            handleDecimalInput(value, name) {
              // 1. 先移除所有非数字和小数点的字符
              let filteredValue = value.replace(/[^\d.]/g, '');

              // 2. 处理开头的小数点
              filteredValue = filteredValue.replace(/^\./g, '');

              // 3. 处理连续的多个小数点（只保留一个）
              filteredValue = filteredValue.replace(/\.+/g, '.');

              // 4. 处理整数部分多余的零（如 000.9 → 0.9）
              if (filteredValue.includes('.')) {
                const parts = filteredValue.split('.');
                // 处理整数部分：去掉前导零，但如果全部是零则保留一个零
                parts[0] = parts[0].replace(/^0+/, '') || '0';
                filteredValue = parts.join('.');
              } else {
                // 如果没有小数点，去掉前导零，但如果全部是零则保留一个零
                filteredValue = filteredValue.replace(/^0+/, '') || '0';
              }

              this.cmd[name] = filteredValue;
            },
            changeName(){
              if(this.cmd.name){
                request({
                  url: "/public/ollama?text="+this.cmd.name,
                  method: 'get',
                }).then(res => {
                  if(res){
                    _this.cmd.usedVram = res.usedVram
                    _this.cmd.minMemory = res.minMemory
                    _this.cmd.minVram = res.minVram
                    _this.cmd.onlineTime = res.updated

                    let modelLen = 0
                    if(res.content){
                      modelLen = parseInt(res.content.slice(0, -1)) * 1000
                    }
                    _this.memoryList.forEach(item => {
                      if(item.min && item.max && item.min <= modelLen && item.max > modelLen){
                        _this.cmd.effect = item.name
                      }else if(item.min && !item.max && modelLen >= item.min){
                        _this.cmd.effect = item.name
                      }else if(!item.min && item.max && modelLen < item.max){
                        _this.cmd.effect = item.name
                      }
                    })
                  }
                }).catch(error =>{
                })
              }

            }
        }
    }
</script>

<style  lang="scss">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
